import { createContext } from 'react';
import { ICustomerLocalizationGroup, IUpdateCustomerLocalization } from 'types';

export type TLocalizationSelectedItem = { id: string | null; name: string | null };
export type TTypeOfModalWindow =
	| null
	| 'toConfirmDeleteItem'
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'addWording';
export interface IDeleteWordingData {
	groupId: string;
	wordingId: string;
}
export type TLocalizationSettingsMode = 'view' | 'edit';

export interface ILocalizationState {
	needRefetchWordings: boolean;
	loading: boolean;
	selectedGroup: TLocalizationSelectedItem | null;
	selectedLanguage: TLocalizationSelectedItem | null;
	groups: ICustomerLocalizationGroup[];
	invalidFields: string[];
	dataForSubmit: IUpdateCustomerLocalization | null;
	deleteWordingData: IDeleteWordingData | null;
	typeOfModalWindow: TTypeOfModalWindow;
	mode: TLocalizationSettingsMode;
}

export const localizationInitialState: ILocalizationState = {
	needRefetchWordings: false,
	loading: true,
	selectedGroup: null,
	selectedLanguage: null,
	groups: [],
	invalidFields: [],
	dataForSubmit: null,
	deleteWordingData: null,
	typeOfModalWindow: null,
	mode: 'view',
};

export interface ILocalizationContext extends ILocalizationState {
	refetchWordings(value: boolean): void;
	setGroup(value: TLocalizationSelectedItem | null): void;
	setLanguage(value: TLocalizationSelectedItem | null): void;
	removeWording(groupId: string, wordingId: string): void;
	addInvalidField(value: string): void;
	clearInvalidFields(): void;
	setDataForSubmit(value: IUpdateCustomerLocalization | null): void;
	setDeleteWordingData(value: IDeleteWordingData | null): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	changeMode(value: TLocalizationSettingsMode): void;
}

export const LocalizationContext = createContext<ILocalizationContext>({
	refetchWordings: () => undefined,
	setGroup: () => undefined,
	setLanguage: () => undefined,
	removeWording: () => undefined,
	addInvalidField: () => undefined,
	clearInvalidFields: () => undefined,
	setDataForSubmit: () => undefined,
	setDeleteWordingData: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	changeMode: () => undefined,
	...localizationInitialState,
});
